import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import TranslateIcon from "@mui/icons-material/Translate";
import { FormControl, MenuItem, Select } from "@mui/material";

export function LanguageDropdown() {
  const { i18n } = useTranslation();
  const handleLanguageChange = async (langSelected) => {
    i18n.changeLanguage(langSelected);
  };

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <FormControl size="small" className="w-full">
      <Select
        value={i18n.language}
        onChange={(e) => handleLanguageChange(e.target.value)}
        displayEmpty
        startAdornment={<TranslateIcon sx={{ mr: 1 }} />}
        sx={{
          minWidth: 120,
          width: "100%",
          backgroundColor: "#F6FBFF",
          borderRadius: "8px",
        }}
      >
        <MenuItem value="en">English</MenuItem>
        <MenuItem value="da">Dansk</MenuItem>
      </Select>
    </FormControl>
  );
}
